<template>
    <div class="help-last">
        <div class="help-mid">
            <ul>
                <li @click="tohelpcon">
                    <mu-icon size="36" value="airplay" color="red"></mu-icon>
                    <h3>注册</h3>
                    <p>访问主页用手机注册即可</p>
                </li>
                <li @click="tohelpcon">
                    <mu-icon size="36" value="settings" color="blue"></mu-icon>
                    <h3>认证</h3>
                    <p>支付宝收款信息认证</p>
                </li>
                <li @click="tohelpcon">
                    <mu-icon size="36" value="share" color="green"></mu-icon>
                    <h3>上架</h3>
                    <p>上架商品添加商品数据</p>
                </li>
                <li @click="tohelpcon">
                    <mu-icon size="36" value="adjust" color="indigo400"></mu-icon>
                    <h3>销售</h3>
                    <p>开启智能零售模式</p>
                </li>
            </ul>
        </div>
        <h2>常见问题分类汇总</h2>
        <ul>
            <li  @click="tohelpcon">

                <h4><mu-icon size="34" value="business" color="blue"></mu-icon><span>商城设置</span></h4>
                <p>
                    基础设置
                </p>
                <p>
                    API管理
                </p>
                <span>查看更多 <mu-icon size="30" value="keyboard_arrow_down" color="red"></mu-icon></span>
            </li>
            <li  @click="tohelpcon">

                <h4><mu-icon size="34" value="business" color="blue"></mu-icon><span>上架商品</span></h4>
                <p>
                    自有商品
                </p>
                <p>API商品</p>
                <span>查看更多 <mu-icon size="30" value="keyboard_arrow_down" color="red"></mu-icon></span>
            </li>
            <li  @click="tohelpcon">
                <h4><mu-icon size="34" value="business" color="blue"></mu-icon><span>营销功能</span></h4>
                <p>
                    代理改价
                </p>
                <p>
                    卡密拼团
                </p>
                <span>查看更多 <mu-icon size="30" value="keyboard_arrow_down" color="red"></mu-icon></span>
            </li>
            <li  @click="tohelpcon">
                <h4><mu-icon size="34" value="business" color="blue"></mu-icon><span>自动发货</span></h4>
                <p>
                    虚拟卡密
                </p>
                <p>图片二维码</p>
                <p>手动代充</p>
                <span>查看更多 <mu-icon size="30" value="keyboard_arrow_down" color="red" ></mu-icon></span>
            </li>
            <li  @click="tohelpcon">
                <h4><mu-icon size="34" value="business" color="blue"></mu-icon><span>代理管理</span></h4>
                <p>
                    代理列表
                </p>
                <p>代理审核</p>
                <p>代理商教程</p>
                <span>查看更多 <mu-icon size="30" value="keyboard_arrow_down" color="red"></mu-icon></span>
            </li>
            <li  @click="tohelpcon">
                <h4> <mu-icon size="34" value="business" color="blue"></mu-icon><span>提现管理</span></h4>
                <p>提现须知</p>
                <span>查看更多 <mu-icon size="30" value="keyboard_arrow_down" color="red"></mu-icon></span>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'helplast',
        methods:{
            tohelpcon(){
                this.$router.push({name:'helpcon'})
            }
        }
    }
</script>
<style scoped>
    .help-mid{
        background: #f7f8fa;
    }

    .help-mid>ul{
        padding: 50px 0;
        width: 1233px;
        height: 300px;
        margin: 0 auto;
        text-align: center;
        list-style: none;
        overflow: hidden;
    }
    .help-mid>ul>li{
        float: left;
        margin-right: 20px;
        padding: 40px 0 28px;
        -webkit-box-shadow: 0px 0px 16px #eaeaea;
        box-shadow: 0px 0px 16px #eaeaea;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        background: #fff;
        width: 285px;
        height: 196px;
        border-radius: 4px;
        font-size: 14px;
        line-height: 30px;
        color: #999;
        position: relative;
        top: 0;
    }
    .help-mid>ul>li:hover{
        top: -20px;
    }
    h3{
        line-height: 40px;
        font-size: 16px;
        color: #333;
    }
    ul{
        list-style: none;
    }
    .help-last{
        width: 100%;
        margin-bottom: 50px;
    }
    .help-last>ul{
        width: 1100px;
        overflow: hidden;
        margin: 0 auto;
    }
    .help-last>ul>li{
        float: left;
        width: 246px;
        margin: 0px 53px;
        overflow: hidden;
    }
    .help-last>ul>li>h4>span{
        position: relative;
        top: -9px;
        left: 9px;
        font-size: 18px;
    }
    .help-last>ul>li>h4{
        text-align: left;
        cursor: pointer;
    }
    .help-last>ul>li>p{
        text-align: left;
        cursor: pointer;
    }
    .help-last>ul>li>p:hover{
        color: red;
    }
    .help-last>ul>li>span{
        float: left;
        color: red;
        cursor: pointer;
    }
    .help-last>ul>li>span>i{
        position: relative!important;
        top: 11px!important;
        left: -8px;
    }


</style>


// WEBPACK FOOTER //
// src/components/help/helplast.vue